import React, { useState } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import Product from '../components/product'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function categories() {
    return (
        <>
            <Header />

            <section className="bg_banner"></section>
            <section className="breadcrumb">
                <div className="container">
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Men's Clothing</li>
                    </ul>
                </div>
            </section>

            <main className="main py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mb-3 border-bottom pb-2">
                            <div className="row">
                                <div className="col-md-11">
                                    <h1 className="fs-3">All Mobiles</h1>
                                </div>
                                <div className="col-md-1">
                                    <div className="right d-flex align-items-center">
                                        <a href='#' title='Grid View' className="grid me-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M14 10v4h-4v-4zm2 0h5v4h-5zm-2 11h-4v-5h4zm2 0v-5h5v4a1 1 0 0 1-1 1zM14 3v5h-4V3zm2 0h4a1 1 0 0 1 1 1v4h-5zm-8 7v4H3v-4zm0 11H4a1 1 0 0 1-1-1v-4h5zM8 3v5H3V4a1 1 0 0 1 1-1z" /></svg>
                                        </a>
                                        <a href='#' title='List View' className="list me-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7zm-4 6h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z" /></svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <aside className="col-md-3 shadow p-4">
                            <strong className="fs_16">Filters & Sort</strong>
                            <div className="box my-3 border-bottom py-2 border-top">
                                <a className="collapse_btn" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                                    <strong className="fs_14 mb-2 d-block ps-2">Choose Color</strong>
                                </a>
                                <div className="list ps-2 collapse" id='collapseExample'>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="color" value={'#00aaff'} className="filter_select" />
                                        <span className="ms-1 fs_13 fw_500">Blue</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="color" value={'#00ffb3'} className="filter_select" />
                                        <span className="ms-1 fs_13 fw_500">Green</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="color" value={'#e100ff'} className="filter_select" />
                                        <span className="ms-1 fs_13 fw_500">Purple</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="color" value={'#ebc234'} className="filter_select" />
                                        <span className="ms-1 fs_13 fw_500">Yellow</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="color" value={'#ff6600'} className="filter_select" />
                                        <span className="ms-1 fs_13 fw_500">Orange</span>
                                    </div>
                                </div>
                            </div>
                            <div className="box my-3 border-bottom pb-2">
                                <a className="collapse_btn" data-bs-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="false" aria-controls="collapseExample1">
                                    <strong className="fs_14 mb-2 d-block ps-2">Brands</strong>
                                </a>
                                <div className="list ps-2 collapse" id='collapseExample1'>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">Apple</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">One Plus</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">Vivo</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">Oppo</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">Redmi</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">Motorolla</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">Lava</span>
                                    </div>
                                </div>
                            </div>
                            <div className="box my-3 border-bottom pb-2">
                                <a className="collapse_btn" data-bs-toggle="collapse" href="#collapseExample3" role="button" aria-expanded="false" aria-controls="collapseExample3">
                                    <strong className="fs_14 mb-2 d-block ps-2">RAM</strong>
                                </a>
                                <div className="list ps-2 collapse" id='collapseExample3'>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">4GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">6GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">8GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">12GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">16GB</span>
                                    </div>
                                </div>
                            </div>
                            <div className="box my-3 border-bottom pb-2">
                                <a className="collapse_btn" data-bs-toggle="collapse" href="#collapseExample4" role="button" aria-expanded="false" aria-controls="collapseExample4">
                                    <strong className="fs_14 mb-2 d-block ps-2">Internal Storage / ROM</strong>
                                </a>
                                <div className="list ps-2 collapse" id='collapseExample4'>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">16GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">32GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">64GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">128GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">256GB</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">512GB</span>
                                    </div>
                                </div>
                            </div>
                            <div className="box my-3 border-bottom pb-2">
                                <a className="collapse_btn" data-bs-toggle="collapse" href="#collapseExample5" role="button" aria-expanded="false" aria-controls="collapseExample5">
                                    <strong className="fs_14 mb-2 d-block ps-2">Battery Capacity</strong>
                                </a>
                                <div className="list ps-2 collapse" id='collapseExample5'>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">2500Mah</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" value="#fffbbb" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">3000Mah</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" value="#dddddd" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">3500Mah</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" value="#ebc234" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">4000Mah</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" value="#ebc234" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">4500Mah</span>
                                    </div>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="checkbox" value="#ebc234" className="check_box" />
                                        <span className="ms-1 fs_13 fw_500">500Mah</span>
                                    </div>
                                </div>
                            </div>
                            <div className="box my-3 border-bottom pb-2">
                                <a className="collapse_btn" data-bs-toggle="collapse" href="#collapseExample6" role="button" aria-expanded="false" aria-controls="collapseExample6">
                                    <strong className="fs_14 mb-2 d-block ps-2">Price</strong>
                                </a>
                                <div className="list ps-2 collapse" id='collapseExample6'>
                                    <div className="check mb-2 d-flex align-items-center">
                                        <input type="range" className="" />
                                        <span className="ms-1 fs_13 fw_500">0 to 1 Lac</span>
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <input className='form-control' type="text" placeholder='0' />
                                        <span className="fs_12">to</span>
                                        <input className='form-control' type="text" placeholder='1,00000' />
                                    </div>
                                    <a href="#" className="default_btn fs_13 mt-2">Search</a>
                                </div>
                            </div>
                        </aside>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-12 mb-4">
                                    <h2 className="fs-4 mb-2">Heading will come here.</h2>
                                    <p className='text-secondary'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio nihil repellat perferendis at maiores nisi dolores cupiditate aliquid laudantium, recusandae obcaecati officiis, voluptatibus esse ipsum eos, odit magnam nostrum. Nisi!</p>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../home/kitchen/cooker.jpeg",
                                        "../home/kitchen/cooker1.jpeg",
                                        "../home/kitchen/cooker2.jpeg",
                                        "../home/kitchen/cooker3.jpeg",
                                        "../home/kitchen/cooker4.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../home/kitchen/coffe-mug.jpeg",
                                        "../home/kitchen/coffe-mug1.jpeg",
                                        "../home/kitchen/coffe-mug2.jpeg",
                                        "../home/kitchen/coffe-mug3.jpeg",
                                        "../home/kitchen/coffe-mug4.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../home/kitchen/lunch-box.jpeg",
                                        "../home/kitchen/lunch-box1.jpeg",
                                        "../home/kitchen/lunch-box2.jpeg",
                                        "../home/kitchen/lunch-box3.jpeg",
                                        "../home/kitchen/lunch-box4.jpeg",
                                        "../home/kitchen/lunch-box5.jpeg",
                                        "../home/kitchen/lunch-box6.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../electronics/bluetooth/noise.jpeg",
                                        "../electronics/bluetooth/noise1.jpeg",
                                        "../electronics/bluetooth/noise2.jpeg",
                                        "../electronics/bluetooth/noise3.jpeg",
                                        "../electronics/bluetooth/noise4.jpeg",
                                        "../electronics/bluetooth/noise5.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../footwear/black.jpeg",
                                        "../footwear/black1.jpeg",
                                        "../footwear/black2.jpeg",
                                        "../footwear/black3.jpeg",
                                        "../footwear/black4.jpeg",
                                        "../footwear/black5.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../footwear/grey.jpeg",
                                        "../footwear/grey1.jpeg",
                                        "../footwear/grey2.jpeg",
                                        "../footwear/grey3.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../footwear/green.jpeg",
                                        "../footwear/green1.jpeg",
                                        "../footwear/green2.jpeg",
                                        "../footwear/green3.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../womens/gown.jpeg",
                                        "../womens/gown1.jpeg",
                                        "../womens/gown2.jpeg",
                                        "../womens/gown3.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../womens/brown.jpeg",
                                        "../womens/brown1.jpeg",
                                        "../womens/brown2.jpeg",
                                        "../womens/brown3.jpeg",
                                        "../womens/brown4.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../womens/heel.jpeg",
                                        "../womens/heel1.jpeg",
                                        "../womens/heel2.jpeg",
                                        "../womens/heel3.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../womens/pink.jpeg",
                                        "../womens/pink1.jpeg",
                                        "../womens/pink2.jpeg",
                                        "../womens/pink3.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../baby/top.jpeg",
                                        "../baby/top1.jpeg",
                                        "../baby/top2.jpeg",
                                        "../baby/top3.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../boy/shorts.jpeg",
                                        "../boy/shorts1.jpeg",
                                        "../boy/shorts2.jpeg",
                                        "../boy/shorts3.jpeg",
                                        "../boy/shorts4.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../baby/footwear.jpeg",
                                        "../baby/footwear1.jpeg",
                                        "../baby/footwear2.jpeg",
                                        "../baby/footwear3.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <Product images={[
                                        "../baby/jacket.jpeg",
                                        "../baby/jacket1.jpeg",
                                        "../baby/jacket2.jpeg",
                                        "../baby/jacket3.jpeg"
                                    ]} />
                                </div>
                                <div className="col-md-10">
                                    <div className="d-flex align-items-center main_load">
                                        <div className="loader"></div>
                                        <span className="fs_13 fw_600">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    )
}
